define('cartware_checkout/components/advises/payment',[
	"jquery",
	"cartware/components/_base",
	"cartware/dom/event/trigger"
], function(
	jQuery,
	Component,
	triggerEvent
) {
	return Component.create({

		billingSection: null,

		init: function() {
			//		var _nextStep = Payment.prototype.nextStep;
//		Payment.prototype.nextStep = function(transport) {
//			/*
//			this.resetLoadWaiting();
//			billing.originalSave();
//			*/
//			_nextStep.apply(this, arguments);
//		}
			this.billingSection = jQuery('#billing-section');

			var self = this;

			var _changeVisible = Payment.prototype.changeVisible;
			Payment.prototype.changeVisible = function(method, mode) {
				_changeVisible.apply(this, arguments);

				var block = 'payment_form_' + method;
				[block + '_before', block, block + '_after'].each(function(el) {
					element = jQuery(el);
					if (element) {
						element.select('input', 'select', 'textarea', 'button').each(function(field) {
							jQuery(field).data('uniformed') && $(field).data('uniformed').update();
							triggerEvent(field, 'change');
						});
					}
				});
			};

			var _switchMethod = Payment.prototype.switchMethod;
			Payment.prototype.switchMethod = function() {
				checkout.setLoadWaiting(true);

				_switchMethod.apply(this, arguments);
				if ("accordion" in window) {
					window.accordion._layout();
				}

				new Ajax.Request(
					this.checkAllowDivergentAddressUrl,
					{
						method: 'post',
						parameters: {payment_method: this.currentMethod},
						onFailure: self._setAllowDivergentAddress,
						onSuccess: function (transport) {
							var response = transport.responseJSON || transport.responseText.evalJSON(true) || {};
							self._setAllowDivergentAddress(response.result);
						},
						onComplete: function () {
							checkout.setLoadWaiting(false);
						}.bind(checkout),
					}
				);
			}
		},

		_setAllowDivergentAddress: function(result) {
			if (result) {
				this.billingSection.show();
			} else {
				this.billingSection.hide();
				billing.setDifferentFromShipping(false);
			}

			window.accordion._layout();
		}

	});
});
